module.exports = __webpack_public_path__ + "img/dashboard-icon-orange.cf6626cb.svg";